import { DatePipe } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import Swal from "sweetalert2";
import { environment } from "src/environments/environment";
@Component({
  selector: "app-mentordash",
  templateUrl: "./mentordash.component.html",
  styleUrls: ["./mentordash.component.css"],
})
export class MentordashComponent implements OnInit {
  addedslots: any;
  firstFormGroup: FormGroup;
  auth: any;
  constructor(
    private _formBuilder: FormBuilder,
    private datePipe: DatePipe,
    private http: HttpClient,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.auth = localStorage.getItem("authToken");
    if (this.auth == null) {
      Swal.fire("Login first to access dashboard");
      this.router.navigate(["/mentorlogin"]);
    } else {
      this.router.navigate(["/mentordash"]);
    }
    this.firstFormGroup = this._formBuilder.group({
      date: ["", Validators.required],
      time: ["", [Validators.required]],
    });
    const headers = {
      Authorization: "Token " + localStorage.getItem("authTokenmentor"),
    };
    this.http
      .get<any>(environment.API_URL + "addedslots/", { headers })
      .subscribe((Response) => {
        this.addedslots = Response.addedslots;
      });
  }

  formatDateAndTime(dateString: string, timeString: string): string {
    if (dateString && timeString) {
      const dateTimeString = `${dateString}T${timeString}`;
      const date = new Date(dateTimeString);

      // Create the Date object without adjusting the timezone offset.
      // const options = { day: 'numeric', month: 'short', hour: 'numeric', minute: 'numeric', hour12: true, timeZone: 'Asia/Kolkata' };
      const formattedDate = this.datePipe.transform(date, "short", "en-US");
      return formattedDate || ""; // Handle any potential formatting errors.
    }
    return "";
  }

  addslot() {
    if (this.firstFormGroup.valid) {
      const headers = {
        Authorization: "Token " + localStorage.getItem("authTokenmentor"),
      };
      var body: any = new FormData();
      body.append("date", this.firstFormGroup.value.date);
      body.append("time", this.firstFormGroup.value.time);
      // this.displayStyles = "block";
      this.http
        .post<any>(environment.API_URL + "addslot/", body, { headers })
        .subscribe((data) => {
          this.http
            .get<any>(environment.API_URL + "addedslots/", { headers })
            .subscribe((Response) => {
              this.addedslots = Response.addedslots;
            });
          Swal.fire(data.status);
        });
    }
  }
}
